import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ObservalbeStateService {

    private onBoardingscreenData = new BehaviorSubject<any>('');
    $onBoardingscreenData = this.onBoardingscreenData.asObservable();

    private pgDetails = new BehaviorSubject<any>('');
    $pgDetails = this.pgDetails.asObservable();

    private bspDetails = new BehaviorSubject<any>('');
    $bspDetails = this.bspDetails.asObservable();

    private prodDetails = new BehaviorSubject<any>('');
    $prodDetails = this.prodDetails.asObservable();

    private onBoradingGridData = new BehaviorSubject<any>('');
    $onBoradingGridData = this.onBoradingGridData.asObservable();

    private menuCode = new BehaviorSubject<any>('');
    $menuCode = this.menuCode.asObservable();

    private bussPlanDetails = new BehaviorSubject<any>('');
    $bussPlanDetails = this.bussPlanDetails.asObservable();

    private fundDetails = new BehaviorSubject<any>('');
    $fundDetails = this.fundDetails.asObservable();

    private pgFormStatus = new BehaviorSubject<any>('');
    $pgFormStatus = this.pgFormStatus.asObservable();

    private incomeDetails = new BehaviorSubject<any>('');
    $incomeDetails = this.incomeDetails.asObservable();

    private pgAddressDetails = new BehaviorSubject<any>('');
    $pgAddressDetails = this.pgAddressDetails.asObservable();

    private showPop = new BehaviorSubject<any>('');
    $showPop = this.showPop.asObservable();

    private splDetails = new BehaviorSubject<any>('');
    $splDetails = this.splDetails.asObservable();

    private procuFundDetails = new BehaviorSubject<any>('');
    $procuFundDetails = this.procuFundDetails.asObservable();

    private procureFundExpense = new BehaviorSubject<any>('');
    $procureFundExpense = this.procureFundExpense.asObservable();

    private procureCostDetails = new BehaviorSubject<any>('');
    $procureCostDetails = this.procureCostDetails.asObservable();
    // this.funddispursment.next(status);
    private funddispursment = new BehaviorSubject<any>('');
    $funddispursment = this.funddispursment.asObservable();

    constructor(public toastrs: ToastrService) { }
     public OnBoardingScreenData(onBoradingGridData: any) {
        this.onBoardingscreenData.next(onBoradingGridData)
    }

    public PGDetails(status: any) {
        this.pgDetails.next(status)
    }

    public BSPDetails(status: any) {
        this.bspDetails.next(status)
    }

    public OnBoardingGridData(onBoardingGridData: any) {
        this.pgDetails.next(onBoardingGridData);
    }
    public MenuCode(status: any) {
        this.menuCode.next(status)
    }

    public PRODDetails(status:any) {
        this.prodDetails.next(status)
    }

    public BussPlanDetail(status: any){
        this.bussPlanDetails.next(status);
    }

    public FundDetails(status:any){
        this.fundDetails.next(status);
    }

    public PGFormStatus(status:any){
        this.pgFormStatus.next(status);
    }

    public IncomeDetails(status:any) {
        this.incomeDetails.next(status);
    }

    public PGAddressDetails(status:any){
        this.pgAddressDetails.next(status);
    }

    public ShowPop(status:any){
        this.showPop.next(status);
    }

    public SPLDetails(status:any){
        this.splDetails.next(status);
    }

    public ProcureFundDetails(status:any){
        this.procuFundDetails.next(status);
    }

    public ProcFundExpense(status:any){
        this.procureFundExpense.next(status);
    }

    public PRCLDetails(status:any){
        this.procureCostDetails.next(status);
    }

    public FUNDDispursment(stauts:any){
        this.funddispursment.next(status);
    }
}